module.exports = __webpack_public_path__ + "static/media/mobile-banner-bg-2023.a2ef5d73.png";